// @ts-strict-ignore
import { APP_STATE } from '@/main/app.constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { angularComponent } from '@/hybrid/core/react2angular.util';

export const Unauthorized = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="unauthorizedPage" className="flexColumnContainer flexCenter fullViewport splashScreen">
      <div className="container ml0 mr0">
        <div className="row flexJustifyCenter">
          <div className="span12">
            <div data-testid="mainContent" className="jumbotron text-center">
              <p>
                <img src="/img/Seeq_logo_darkBlue_sm.png" />
              </p>
              <h2 className="mb10">{t('UNAUTHORIZED.TITLE')}</h2>
              <p>{t('UNAUTHORIZED.DESCRIPTION')}</p>
              <p>{t('UNAUTHORIZED.CONTACT_OWNER')}</p>
              <p>
                <a href={APP_STATE.WORKBOOKS}>{t('UNAUTHORIZED.WORKBOOK_OVERVIEW')}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const sqUnauthorized = angularComponent(null, Unauthorized);
